import React, { FC } from "react";
import tick from "assets/images/tick.png";
import download from "assets/images/download.svg";

interface MsgProps {
  policyData: any;
}

const msgStyles: any = {
  Healthy: {
    container: "bg-[#E2FDF0] border-green-300 2xl:p-4 py-4 flex items-center gap-2",
    title: "text-[#2BA882] font-extrabold text-2xl uppercase",
    message: "Your policy status looks good",
    icon: <img src={tick} alt="" />,
    extra: "Congratulations!",
    img: <img src={download} />
  },
  Critical: {
    container: "bg-[#FFE9E9] p-4 flex items-center gap-2",
    title: "text-[#E55454] font-extrabold text-2xl uppercase",
    message: "Based on your responses, there are few critical errors in your policy’s personal information.",
    icon: "",
    extra: ""
  },
  "Needs Attention": {
    container: "bg-[#FFF1E9] p-4 flex items-center gap-2",
    title: "text-[#F78C4F] font-extrabold text-2xl uppercase",
    message: "Based on your responses, there are few errors in your policy’s personal information.",
    icon: "",
    extra: ""
  }
};
export const Msg: FC<MsgProps> = ({ policyData }) => {
  const type = policyData?.ResultTitle;
  const style = msgStyles[type];

  return (
    <div className={`${style?.container} hidden w-full md:flex flex-col 2xl:flex-row justify-center items-center gap-2`}>
      {/* mobile view */}
      <div className="w-full flex justify-between items-center 2xl:hidden">
        <span className={`${style.title} ml-4`}>{type}</span>
        {style.extra && (
          <span className="flex items-end mr-0 ">
            <span className="font-bold">{style.img}</span>
          </span>
        )}
      </div>
      <span className="w-full text-start 2xl:text-left font-medium 2xl:hidden pl-4 pr-1">{style.message}</span>

      {/* Desktop */}
      <div className="hidden 2xl:flex items-center gap-2">
        <div className="flex items-center mr-3">
          <span className={`${style.title} text-[24px]`}>{type}</span>
        </div>
        <span className="text-left font-medium text-[16px]">{style.message}</span>
        {style.extra && (
          <span className="flex items-center gap-1 font-semibold text-black">
            <span>{style.icon}</span>
            <span className="font-bold">{style.extra}</span>
          </span>
        )}
      </div>
    </div>
  );
};
